import React, { useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
const ModalCopySignature = ({ copyFunc }) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [loading, setLoading] = useState(false);
  const platforms = ["Gmail", "Outlook", "Apple", "Other"];
  const tutorials = {
    Gmail: [
      {
        main: "Open Gmail",
      },
      {
        main: "At the top right, click Settings → See all settings",
      },
      {
        main: 'In the "Signature" section, paste your signature text in the box',
      },
      {
        main: "At the bottom of the page, click Save Changes",
      },
    ],
    Outlook: [
      {
        main: "Platfrom",
        child: [
          "Desktop: File → Options → Mail → Signatures",
          "Settings → View all settings → Mail → Compose and reply",
        ],
      },
      {
        main: "Click New → Name your signature",
      },
      {
        main: "Click image icon → Upload",
      },
      {
        main: "Set as default → Click OK/Save",
      },
    ],
    Apple: [
      {
        main: "Mail → Settings → Signatures tab",
      },
      {
        main: "Select email account → Click + button",
      },
      {
        main: "Paste image into editor",
      },
      {
        main: 'Choose signature in "Choose Signature" dropdown',
      },
    ],
    Other: [
      {
        main: "Platform",
        child: [
          "Thunderbird: Settings → Account Settings → Select account → Use signature editor or attach HTML file",
          "Yahoo: ⚙️ Settings → More Settings → Writing email → Signature section",
          "Proton Mail: Settings → Identity and addresses → Signature (limited HTML support)",
        ],
      },
    ],
  };
  const [activeSection, setActiveSection] = useState(platforms[0]);
  const handleOnClickCopy = async (e) => {
    setLoading(true);
    console.log("Click copy");
  };
  return (
    <dialog id="copy_signature_modal" className="modal shadow-2xl">
      <ToastContainer />
      <div className="modal-box flex flex-col justify-between w-full md:w-[600px] p-10 h-fit md:h-[600px]">
        <div className="flex flex-col gap-5 mt-5">
          <div className="flex flex-row w-full" id="emailPlatform">
            {platforms.map((v, i) => (
              <div
                className={`px-5 py-4 cursor-pointer hover:text-black ${
                  activeSection == v
                    ? "bg-gray-200 rounded-lg hover:text-secondary"
                    : ""
                }`}
                key={i}
                id={v}
                onClick={() => setActiveSection(v)}
              >
                {v}
              </div>
            ))}
          </div>
          <hr />
          <div className="font-bold">Instruction</div>
          <ul className="flex flex-col list-decimal ml-4 gap-5">
            <li className="">
              Copy your signature{"  "}
              <span
                className="ml-3 rounded-lg bg-primary text-white px-4
                py-2 hover:bg-secondary cursor-pointer"
                onClick={copyFunc}
              >
                Copy
              </span>
            </li>
            {tutorials[activeSection].map((v, i) => (
              <>
                <li key={i}>{v.main}</li>
                {v.child && (
                  <ul className="flex flex-col list-disc gap-3 ml-4">
                    {v.child.map((v_, i_) => (
                      <li key={i_ + 11}>{v_}</li>
                    ))}
                  </ul>
                )}
              </>
            ))}
          </ul>
        </div>
        <form
          method="dialog"
          className="flex flex-row justify-end items-center"
        >
          <button className="btn btn-sm bg-primary text-white rounded-lg">
            Done
          </button>
        </form>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  );
};

export default ModalCopySignature;
